import { Component, effect, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { TransactionsReportConstant } from './report-transactions-basic.constants';
import { ReportTransactionService } from './report-transactions-basic.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { TransactionsMenuEnum } from './report-transactions-basic.enum';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { UnitTypeEnum } from '../../models/unit-type-enum';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DataType } from 'src/app/common/models/enums/common.enum';
import { Label } from '@amcharts/amcharts5';
import { ReportTableDropdown } from '../../models/reports.model';
import { MessageDialogBoxComponent } from 'src/app/common/components/message-dialog-box/message-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-report-transactions-basic',
  templateUrl: './report-transactions-basic.component.html',
  styleUrls: ['./report-transactions-basic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportTransactionsBasicComponent implements OnInit, OnChanges {

  @Input() params: any;
  @Input() multi_story_residential: boolean = false;
  // value: string;
  //   id: any;
  transactionType: ReportTableDropdown = {
    label: "Select applicable options",
    data: [{
      value: 'Actual',
      id: 'Actual'
    }, {
      value: 'Estimate',
      id: 'Estimation'
    }, {
      value: 'Quote',
      id: 'Quote'
    }],
    default: "Actual",
    maxSelect: 3,
    reportType: true
  }
  transactionsMenuEnum = TransactionsMenuEnum;
  langName: any;
  transactionMenu = TransactionsReportConstant.transactionMenu;
  propertyTransactionColumns:any;// = TransactionsReportConstant.propertyTransactionColumns;
  unitTransactionColumns = TransactionsReportConstant.unitTransactionColumns;
  propertyTransactionExpandColumns = TransactionsReportConstant.propertyTransactionExpandColumns
  unitTransactionExpandColumns = TransactionsReportConstant.unitTransactionExpandColumns
  currentScroll: any = '';
  UnitTypeEnum = UnitTypeEnum;
  propertyTransactiondata: any = [];
  propertyTransactionCount: number = 0;
  propertyTransactionActualAuctionCount: number = 0;
  propertyTransactionEstimatedCount: number = 0;
  unitTransactiondata: any = [];
  unitTransactionCount: number = 0;
  unitTransactionActualAuctionCount: number = 0;
  unitTransactionEstimatedCount: number = 0;
  transactionOverview: any = null;
  unitTransactionOverview: any = null;
  propertyTransactionOverview: any = null;
  showPropertyDetails: boolean = false;
  userInfo: any = 0;
  placeCode: string = '';
  CurrencyCode: string = '';
  propertyInfo: any = null;
  transactionPropertyDetails$ = new Subscription();
  isFirstTime = true;
  unitTransactiondataLoading: boolean = false;
  propertyTransactiondataLoading: boolean = false;
  overViewLoading: boolean = false;
  chartView = ReportsChartEnum;
  downloadLoading: any = {
    a: false,
    b: false
  };
  BHRCHECK = environment.BHRCHECK
  propertyTypes:any[] = [];
  unitTypes:any[] = [];
  activeTab:any;
  tableName:any;
  activeTabName: string = 'property';
  constructor(
    private reportTransactionService: ReportTransactionService,
    public reportService: ReportService,
    private sharedService: SharedService,
    private alertService: AlertService,
    private translate: TranslateService,
    private matdialog: MatDialog
  ){
    effect(()=> {this.activeTab = this.sharedService.activeTab()});
    this.sharedService.language$.subscribe(lang => {
      this.langName = lang;
      if (lang && !this.isFirstTime) {
        this.getReports();
      }
    })
  }

  ngOnInit() {
    this.propertyTypes = this.transactionType.data.map(e => { return e.id });
    this.unitTypes = this.transactionType.data.map(e => { return e.id });
    this.getReports();
    this.isFirstTime = false;
    this.transactionPropertyDetails();
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);

    // this.propertyTransactionColumns.map((e: any) => {
    //   if (this.placeCode == this.BHRCHECK) {
    //     if (e.header == 'transaction_rate') e['symbol'] = DataType.currencyWithSquareFeet;
    //   } else {
    //     if (e.header == 'transaction_rate') e['symbol'] = DataType.currencyWithSquareMeter;
    //   }
    // })
    if(this.placeCode == this.BHRCHECK){
      this.propertyTransactionColumns = TransactionsReportConstant.propertyTransactionBHRColumns;
    }else{
      this.propertyTransactionColumns = TransactionsReportConstant.propertyTransactionColumns;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      this.reportTransactionService.propertyTransactionPayload.pageNumber = 0;
      this.reportTransactionService.unitTransactionPayload.pageNumber = 0;
      this.propertyInfo = null;
      this.showPropertyDetails = false;
      this.getReports();
    }
  }
  lastClickedTable(event:Event, table:any){
    this.tableName = table
  }
  transactionPropertyDetails() {
    this.transactionPropertyDetails$ = this.reportService.transactionPropertyDetails.subscribe((data) => {
      if (data) {
        this.showPropertyDetails = true;
        this.propertyInfo = data;
      } else {
        this.showPropertyDetails = false;
        this.propertyInfo = null;
      }

    });
  }


  getReports() {
    // this.getTransactionSummary();
    this.getUnitTransactionSummary();
    this.getPropertyTransactionSummary();
    this.getPropertyTransaction();
    this.getUnitTransaction();
  }

  getTransactionSummary(year = null) {
    this.overViewLoading = true;
    this.reportTransactionService.getTransactionSummary(year).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.transactionOverview = this.reportTransactionService.formatOverViewTransaction(res.data[0])
          } else {
            this.transactionOverview = null;
          }
          this.overViewLoading = false;
        },
        error: (error: any) => {
          this.transactionOverview = null;
          this.overViewLoading = false;
        }
      }
    )
  }
  getUnitTransactionSummary(year = null) {
    this.overViewLoading = true;
    this.reportTransactionService.getUnitTransactionSummary(year).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.unitTransactionOverview = this.reportTransactionService.formatOverViewTransaction(res.data[0])
          } else {
            this.unitTransactionOverview = null;
          }
          this.overViewLoading = false;
        },
        error: (error: any) => {
          this.unitTransactionOverview = null;
          this.overViewLoading = false;
        }
      }
    )
  }
  getPropertyTransactionSummary(year = null) {
    this.overViewLoading = true;
    this.reportTransactionService.getPropertyTransactionSummary(year).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.propertyTransactionOverview = this.reportTransactionService.formatOverViewTransaction(res.data[0])
          } else {
            this.propertyTransactionOverview = null;
          }
          this.overViewLoading = false;
        },
        error: (error: any) => {
          this.propertyTransactionOverview = null;
          this.overViewLoading = false;
        }
      }
    )
  }

  getPropertyTransaction(year = null) {
    this.propertyTransactiondataLoading = true;
    const type = { ...this.reportService.queryParams }?.price_type;
    this.reportTransactionService.getPropertyTransaction(this.reportTransactionService.propertyTransactionPayload, year, type).subscribe(
      {
        next: (res: any) => {

          if (res.status === 200) {
            let data = res.data.map((value: any) => {
              //if source type so transaction_type concat with source_type
            if(value?.source_type) value['transaction_type'] = value['transaction_type'] + ` (${value?.source_type})`;
              value['value'] = this.reportType(value);
              value['transaction_date'] = value.transaction_date ? moment.utc(value.transaction_date).local().format('DD MMM YYYY') : null;
              if (value?.details) {
                for (let i = 0; i < value?.details.length; i++) {
                  value.details[i]['transaction_date'] = value?.details[i]?.transaction_date ? moment.utc(value.details[i].transaction_date).local().format('DD MMM YYYY') : null
                  // value.details[i]['record_type'] = this.reportType(value.details[i])
                  value.details[i]['value'] = this.reportType(value.details[i]);
                  //if source type so transaction_type concat with source_type
                  if(value.details[i]?.source_type) value.details[i]['transaction_type'] =  (value.details[i]['transaction_type'] + ` (${value.details[i]?.source_type})`);
                }
              }
              if (value.lat && value.lon) {
                value.centroid = {
                  coordinates: [value.lon, value.lat]
                }
              }
              return value;
            });
            this.propertyTransactiondata = this.reportService.setTableDataSource(data);
            if (this.reportTransactionService.propertyTransactionPayload.pageNumber == 0) {
              this.propertyTransactionCount = res.count;
              this.propertyTransactionActualAuctionCount = (res.actual_count || 0) + (res.auction_count || 0);
              this.propertyTransactionEstimatedCount = res.estimate_quote_count;
            }
          } else {
            this.propertyTransactiondata = [];
            this.propertyTransactionCount = 0;
            this.propertyTransactionActualAuctionCount = 0;
            this.propertyTransactionEstimatedCount = 0;
          }
          this.propertyTransactiondataLoading = false;
        },
        error: (error: any) => {
          this.propertyTransactiondata = [];
          this.propertyTransactionCount = 0;
          this.propertyTransactionActualAuctionCount = 0;
          this.propertyTransactionEstimatedCount = 0;
          this.propertyTransactiondataLoading = false;
        }
      }
    )
  }

  getUnitTransaction(year = null) {
    this.unitTransactiondataLoading = true;
    const type = { ...this.reportService.queryParams }?.price_type;
    this.reportTransactionService.getUnitTransaction(this.reportTransactionService.unitTransactionPayload, year, type).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            let data = res.data.map((value: any) => {
              //if source type so transaction_type concat with source_type
            if(value?.source_type) value['transaction_type_m'] = value['transaction_type_m'] + ` (${value?.source_type.toUpperCase()})`;
              // value['record_type'] = this.reportType(value)
              value['transaction_date'] = value.transaction_date ? moment.utc(value.transaction_date).local().format('DD MMM YYYY') : null;
              value['date'] = value.date ? moment.utc(value.date).local().format('DD MMM YYYY') : null;
              if (value?.details) {
                for (let i = 0; i < value?.details.length; i++) {
                  value.details[i]['transaction_date'] = value?.details[i]?.transaction_date ? moment.utc(value.details[i].transaction_date).local().format('DD MMM YYYY') : null
                  value.details[i]['date'] = value?.details[i]?.date ? moment.utc(value.details[i].date).local().format('DD MMM YYYY') : null
                  // value.details[i]['record_type'] = this.reportType(value.details[i])
                  //
                  value.details[i]['property_name'] = null;
                  value.details[i]['unit_uid'] = null;
                  //if source type so transaction_type concat with source_type
                  if(value.details[i]?.source_type) value.details[i]['transaction_type_m'] =  (value.details[i]['transaction_type_m'] + ` (${value.details[i]?.source_type})`);
                }
              }
              if (value.p_lat && value.p_lon) {
                value.centroid = {
                  coordinates: [value.p_lon, value.p_lat]
                }
              }
              //extracted the transaction rate (Transaction Value / Unit  Area)
              value['transaction_rate'] = value.transaction_rate;//value.value / value.u_unit_area;
              // if(value['transaction_rate'] == Infinity || value['transaction_rate'] == -Infinity) value['transaction_rate'] = 0;
              return value;
            });
            this.unitTransactiondata = this.reportService.setTableDataSource(data);
            if (this.reportTransactionService.unitTransactionPayload.pageNumber == 0) {
              this.unitTransactionCount = res.count;
              this.unitTransactionActualAuctionCount = (res.actual_count || 0) + (res.auction_count || 0);
              this.unitTransactionEstimatedCount = res.estimate_quote_count;
            }
          } else {
            this.unitTransactiondata = [];
            this.unitTransactionCount = 0;
            this.unitTransactionActualAuctionCount = 0;
            this.unitTransactionEstimatedCount = 0;
          }
          this.unitTransactiondataLoading = false;
        },
        error: (error: any) => {
          this.unitTransactiondata = [];
          this.unitTransactionCount = 0;
          this.unitTransactionActualAuctionCount = 0;
          this.unitTransactionEstimatedCount = 0;
          this.unitTransactiondataLoading = false;
        }
      }
    )
  }

  reportType(value: any): string {
    let recordType = `<div class="reportType-value">${value.value ? this.reportService.numFormat(value.value): ''}</div>`;
    if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
      recordType += `<div class="reportType-land"><del>${this.translate.instant(value?.prop_type_govt)}</del><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span></div>`;
    } else if (value?.prop_type_govt) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_govt)}</div>`;
    } else if (value?.prop_type_estater) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_estater)}</div>`;
    }
    return recordType;
  }

  onPageEvent(e: any, report: string) {
    if (report === 'property_transaction') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.reportTransactionService.propertyTransactionPayload.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getPropertyTransaction();
    } else if (report === 'unit_transaction') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.reportTransactionService.unitTransactionPayload.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getUnitTransaction();
    }

  }

  menuChangeValue(menu: any){
    this.activeTab = menu.name;
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  sortData(event: any, report: string) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    if (report === 'property_transaction') {
      this.propertyTypes = event?.selectedOptions
      this.reportTransactionService.propertyTransactionPayload.pageNumber = 0;
      this.reportTransactionService.propertyTransactionPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getPropertyTransaction();
    } else {
      this.unitTypes = event?.selectedOptions;
      this.reportTransactionService.unitTransactionPayload.pageNumber = 0;
      this.reportTransactionService.unitTransactionPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getUnitTransaction();
    }
  }

  downloadTransactionReport(type: string, module_name: string, key: any) {
    this.downloadLoading[key] = true;
    this.reportTransactionService.downloadTransactionReport(type, this.userInfo?.user_id).subscribe(
      {
        next: (res: any) => {
          this.downloadLoading[key] = false;
          if (res.status === 200) {
            const downloadUrl = `${this.reportTransactionService.downloadExcelUrl()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=${module_name}`;
            this.sharedService.downloadExcelUrl(downloadUrl);
            this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));
          } else {
            this.alertService.warn(res.message)
            // this.unitTransactiondata = [];
            // this.unitTransactionCount = 0;
          }
        },
        error: (error: any) => {
          this.downloadLoading[key] = false;
        }
      }
    )
  }

  scrollPoint(menu: string) {
    document.getElementById(`${menu}`)?.scrollIntoView({ behavior: "smooth" })
  }

  downloadExcel(event: any, type: string, key: any) {
    this.downloadTransactionReport(type, 'transaction', key);
    const dialogRef = this.matdialog.open(MessageDialogBoxComponent, {
      width: '480px'
    })

    setTimeout(() => {
      dialogRef.close();
    }, 5000);
  }

  selectedYear(data: any) {
    if (data.reportType === 'property') {
      this.reportTransactionService.propertyTransactionPayload.pageNumber = 0;
      this.reportTransactionService.propertyTransactionPayload.year = data.year;
      this.getPropertyTransaction();
    } else {
      this.reportTransactionService.unitTransactionPayload.pageNumber = 0;
      this.reportTransactionService.unitTransactionPayload.year = data.year;
      this.getUnitTransaction();
    }
  }

  ngOnDestroy() {
    this.transactionPropertyDetails$.unsubscribe()
  }
}
